import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'radius-top-left', 'IconRadiusTopLeft', [["path",{"d":"M5 19v-6a8 8 0 0 1 8 -8h6","key":"svg-0"}]]);